// extracted by mini-css-extract-plugin
export default {"startup-suspense__content_hidden":"StartupSuspense-module__startup-suspense__content_hidden--c2bsw"};